import { map } from 'lodash'
import { LocationTypeData } from '../apis/locationType.api'

export default {
  selectOptions (locationTypes: LocationTypeData[]) {
    return map(locationTypes, locationType => {
      const { name, id } = locationType
      return { name, value: String(id) }
    })
  }
}
